module.exports = __webpack_public_path__ + "img/icon_benefit_05_02_w.f4607250.svg";